module.exports = __webpack_public_path__ + "media/images/icons/twotone/check-square-ddb86011b235b712a15db54ab6a6ae67.svg";